import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyaryoSeibihiyoGetListReq,
  TSyaryoSeibihiyoGetListRes,
} from "./TSyaryoSeibihiyoList"

/**
 * 車輌整備費用一覧に対するAPIリクエスト用サービス
 *
 * @export
 * @class syaryoSeibihiyoListService
 * @extends {ConnectApi}
 */
export default class SyaryoSeibihiyoListService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyaryoSeibihiyoGetListReq} params
   * @memberof SyaryoKeihiService
   */
  getList = async (params: TSyaryoSeibihiyoGetListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyaryoSeibihiyoGetListRes>> =
        await this.getInner(`budget/syaryoseibihiyo/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
